(function() {

	var form = $( '.form-newsletter-form' );

	var inactivityTime = function () {

		var time;

		window.addEventListener( 'load', resetTimer, true );
		var events = [ 'mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart' ];

		events.forEach( function( name ) {

			document.addEventListener( name, resetTimer, true );

		});

		function resetTimer() {

			clearTimeout( time );

			time = setTimeout( function() {

				if( window.theme.cart_popup && ( window.theme.cart_popup.title || window.theme.cart_popup.message ) ) {

					$( "#cart-popup-link" ).fancybox({

						type : 'inline',
						baseClass : 'modal-inline-wrap',

					}).trigger( 'click' );

				}


			}, ( window.theme.cart_popup.threshold * 60000 ) )

		}

	};

	//cart popup

	$( document ).ready( function () {

		if( $( "#cart-popup-link" ) && window.theme.cart_popup.threshold ) {

			inactivityTime();

		}

	});

})();

